import React, { useEffect, useState } from "react";
import axios from "axios";
import { Table, Container, FloatingLabel, Form } from "react-bootstrap";

const Crypto = () => {
  const [list, setList] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    axios
      .get("https://openapiv1.coinstats.app/coins", {
        headers: {
          "X-API-KEY": "MkI0UOiSpmYELkzlAAXLXHp3xx/sSqorNLC82RWA1VQ=",
        },
      })
      .then((res) =>{ 
      setList(res.data.result);
      console.log(res.data)
    });
  }, []);

  const listCoins = list.filter((coin) => {
    return coin.name.toLowerCase().includes(search.toLowerCase());
  });

  return (
    <>
      <header className="d-flex justify-content-center align-items-center">
        <div>
          <h2>Enter Crypto Name to see Details</h2>
          <div className="d-flex justify-content-center align-items-center">
            <FloatingLabel
              className="label1"
              controlId="floatingInput"
              label="Search coin"
            >
              <Form.Control
                type="text"
                placeholder="Enter the crypto"
                onChange={(e) => setSearch(e.target.value)}
              ></Form.Control>
            </FloatingLabel>
          </div>
        </div>
      </header>
      <section>
        <Container>
          
            <Table responsive variant="dark">
              <thead>
                <tr>
                  <th scope="col" className="rank">
                    Rank
                  </th>
                  <th scope="col">Name</th>
                  <th scope="col">Symbol</th>
                  <th scope="col">Price</th>
                  <th scope="col">Price Change(1d)</th>
                  <th scope="col">Volume(1d)</th>
                  <th scope="col">marketCap</th>
                </tr>
              </thead>
              <tbody className="table-group-divider">
                {listCoins.map((coin, index) => {
                  return (
                    <tr key={index}>
                      <td className="rank">{coin.rank}</td>
                      <td>
                        <div className="logo">
                          <a href={coin.websiteUrl}>
                            <img src={coin.icon} alt="crypto coins" />
                          </a>
                          <p>{coin.name}</p>
                        </div>
                      </td>
                      <td>{coin.symbol}</td>
                      <td>${coin.price.toFixed(2)}</td>
                      <td>
                        {coin.priceChange1d > 0 ? (
                          <p className="green">{coin.priceChange1d}%</p>
                        ) : (
                          <p className="red">{coin.priceChange1d}%</p>
                        )}
                      </td>
                      <td>{coin.volume.toFixed(2)}</td>
                      <td>{coin.marketCap.toFixed(2)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
        </Container>
      </section>
    </>
  );
};

export default Crypto;
